import React from "react"
import { toMoney } from "../../utils/string_utils"
import "./summary-row.scss"
import { PropTypes } from "prop-types"

const SummaryRow = ({ image, text, rowSpan, heading, costs, excludeVAT }) => (
  <tr className="summary-row">
    {image && (
      <td className="image" rowSpan={rowSpan}>
        <img src={image} alt={text} />
      </td>
    )}
    <td className="text">
      {text && (
        <div
          className="summary-heading"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </td>
    <td className="heading"> {heading && <div>{heading}</div>}</td>
    <td className="upfront-cost">
      {!!costs.upfront && toMoney(costs.upfront)}
      {costs.upfront === 0 && "Free"}
      {excludeVAT && costs.upfront && (
        <div className="vatDescription">(exc. VAT)</div>
      )}
    </td>
    <td className="monthly-cost">
      {!!costs.monthly && toMoney(costs.monthly)}
      {costs.monthly === 0 && "Free"}
      {excludeVAT && costs.monthly && (
        <div className="vatDescription">(exc. VAT)</div>
      )}
    </td>
  </tr>
)

SummaryRow.propTypes = {
  image: PropTypes.string,
  text: PropTypes.string,
  rowSpan: PropTypes.number,
  heading: PropTypes.string,
  costs: PropTypes.object,
  excludeVAT: PropTypes.bool
}

export default SummaryRow
